import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const reviews = [{
  name: 'Олена М.',
  text: 'Валентина — справжній професіонал! Вона ідеально підібрала колір, який я так довго шукала. Волосся після фарбування виглядає живим і блискучим.'
}, {
  name: 'Марія К.',
  text: "Пройшла курс 'Колористика з нуля'. Дуже задоволена подачею матеріалу та кількістю практики. Тепер впевнено працюю з клієнтами."
}, {
  name: 'Ірина В.',
  text: "Робила біозавивку. Результат перевершив усі очікування! Локони виглядають дуже природно, а волосся залишилося м'яким."
}];
export function Reviews() {
  return <section className="py-32 bg-surface" data-id="element-231">
      <div className="container mx-auto px-6 md:px-12" data-id="element-232">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-233">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-234">
            Відгуки
          </h2>
          <div className="w-12 h-1 bg-ink mx-auto rounded-full mb-8" data-id="element-235"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-236">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: 'easeOut'
        }} className="relative bg-white p-10 rounded-[2rem] border border-line shadow-sm hover:shadow-xl transition-shadow duration-500" data-id="element-237">
              <Quote className="text-muted/30 mb-8" size={40} strokeWidth={1.5} data-id="element-238" />
              <p className="text-muted font-normal text-base leading-relaxed mb-8 relative z-10 italic" data-id="element-239">
                "{review.text}"
              </p>
              <div className="flex items-center mt-auto" data-id="element-240">
                <div className="w-8 h-px bg-ink mr-4" data-id="element-241"></div>
                <p className="font-heading font-semibold tracking-tight text-ink text-lg" data-id="element-242">
                  {review.name}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}